module.exports = __webpack_public_path__ + "static/media/Press.6efb0f9b.svg";